import { useEffect, useState } from 'react';

/**
 * Up to this width a screen is a phone (spec 173): Tailwind's `sm` breakpoint
 * is 640px, and a phone held sideways stays under 768px.
 */
export const PHONE_MAX_WIDTH = 767;

/** Whether `(max-width: <px>px)` matches, following the viewport. */
export function useMaxWidth(px: number): boolean {
  // Read at once, not only in the effect: a dialog open on arrival (a task
  // from a link) is a bottom sheet on a phone (spec 261), and starting from
  // `false` drew it as a desktop dialog for a frame, then remounted it.
  const [matches, setMatches] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(`(max-width: ${String(px)}px)`).matches,
  );
  useEffect(() => {
    const query = window.matchMedia(`(max-width: ${String(px)}px)`);
    const sync = (event: MediaQueryList | MediaQueryListEvent) => {
      setMatches(event.matches);
    };
    sync(query);
    query.addEventListener('change', sync);
    return () => {
      query.removeEventListener('change', sync);
    };
  }, [px]);
  return matches;
}

/** Whether the screen is a phone's (spec 173). */
export function usePhoneWidth(): boolean {
  return useMaxWidth(PHONE_MAX_WIDTH);
}
